import { defineStore } from 'pinia'

export const useImageStore = defineStore('images', () => {
  const tickets = ref(0)
  const currentInQueue = ref(0)
  const loadedImages = ref([])

  const ticket = () => tickets.value++
  const nextInQueue = () => {
    if (currentInQueue.value + 1 < tickets.value) currentInQueue.value++
    else { tickets.value = 0; currentInQueue.value = 0 }
  }
  const loaded = (url) => loadedImages.value.push(url)

  return { ticket, currentInQueue, nextInQueue, loaded, loadedImages }
})
